// apiClient.js

/**
 * A helper function for making API requests that automatically attaches
 * the access token from localStorage.
 *
 * @param {string} url - The API endpoint to call.
 * @param {object} options - Additional options for fetch (method, body, etc.).
 * @returns {Promise<Response>} - The fetch response.
 */
export async function apiFetch(url, options = {}) {
    // Retrieve the access token from localStorage
    const token = localStorage.getItem("access_token");

    // Define the default headers
    const defaultHeaders = {
        "Content-Type": "application/json",
    };

    // If a token exists, add the Authorization header
    if (token) {
        defaultHeaders["Authorization"] = `Bearer ${token}`;
    }

    // Merge any headers passed in the options with the default headers
    const headers = {
        ...defaultHeaders,
        ...(options.headers || {}),
    };

    // Prepare the final options for fetch
    const fetchOptions = {
        ...options,
        headers,
    };

    // Make the fetch request and return the response
    return await fetch(url, fetchOptions);
}